export default function PageHeader({ eyebrow, title, description, actions, tint, icon: Icon }) {
  // If a tint is provided, render as a module hero
  if (tint) {
    return (
      <div className={`module-hero tint-${tint} mb-8`} data-testid="module-hero">
        <div className="flex flex-wrap items-end justify-between gap-6 relative z-[1]">
          <div className="min-w-0 max-w-3xl flex gap-5 items-start">
            {Icon && (
              <div className="hero-icon shrink-0 hidden sm:flex w-14 h-14 rounded-2xl bg-[color:hsl(var(--card))] border border-border items-center justify-center">
                <Icon size={26} weight="duotone" />
              </div>
            )}
            <div className="min-w-0">
              {eyebrow && (
                <div className="label-eyebrow mb-2 flex items-center gap-2" data-testid="page-eyebrow">
                  <span className="inline-block w-4 h-px" style={{ background: "hsl(var(--tint))" }} />
                  {eyebrow}
                </div>
              )}
              <h1 className="display-1" data-testid="page-title">{title}</h1>
              {description && (
                <p className="text-[15px] text-muted-foreground mt-3 leading-relaxed max-w-2xl">{description}</p>
              )}
            </div>
          </div>
          {actions && (
            <div className="flex items-center gap-2 shrink-0 flex-wrap">{actions}</div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="mb-8 pb-6 border-b border-border/70">
      <div className="flex flex-wrap items-end justify-between gap-6">
        <div className="min-w-0 max-w-3xl">
          {eyebrow && (
            <div className="label-eyebrow mb-3 flex items-center gap-2" data-testid="page-eyebrow">
              <span className="inline-block w-4 h-px bg-[color:hsl(var(--brand))]" />
              {eyebrow}
            </div>
          )}
          <h1 className="display-1" data-testid="page-title">{title}</h1>
          {description && (
            <p className="text-[15px] text-muted-foreground mt-3 leading-relaxed max-w-2xl">
              {description}
            </p>
          )}
        </div>
        {actions && (
          <div className="flex items-center gap-2 shrink-0 flex-wrap">{actions}</div>
        )}
      </div>
    </div>
  );
}

export function Skeleton({ className = "h-4 w-full" }) {
  return <div className={`skeleton ${className}`} />;
}

export function EmptyState({ icon: Icon, title, description, action }) {
  return (
    <div className="empty-state" data-testid="empty-state">
      {Icon && (
        <div className="empty-icon">
          <Icon size={22} weight="light" />
        </div>
      )}
      <div className="display-3">{title}</div>
      {description && (
        <p className="text-sm text-muted-foreground mt-2 max-w-md">{description}</p>
      )}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}

/* Floating-label field helper */
export function FloatField({ label, value, onChange, type = "text", required, testid, className = "", asTextarea, children, ...rest }) {
  const hasValue = value !== undefined && value !== null && String(value).length > 0;
  const Cmp = asTextarea ? "textarea" : "input";
  if (children) {
    // used with <select> (children provide options)
    return (
      <div className={`float-field is-select has-value ${className}`}>
        {children}
        <label>{label}</label>
      </div>
    );
  }
  return (
    <div className={`float-field ${hasValue ? "has-value" : ""} ${className}`}>
      <Cmp placeholder=" " value={value ?? ""} onChange={onChange} type={type} required={required} data-testid={testid} {...rest} />
      <label>{label}</label>
    </div>
  );
}
